import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Count } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class CountModule extends VuexModule {
    @Action
    [Count.getCountList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/counts/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Count.findPageCount](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/counts`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Count.saveCount](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/counts/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Count.deleteCount](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/counts/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}